import { render, staticRenderFns } from "./StyleManagerMenu.vue?vue&type=template&id=2a82158e&scoped=true"
import script from "./StyleManagerMenu.vue?vue&type=script&lang=js"
export * from "./StyleManagerMenu.vue?vue&type=script&lang=js"
import style0 from "./StyleManagerMenu.vue?vue&type=style&index=0&id=2a82158e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82158e",
  null
  
)

export default component.exports